import request from '../utils/fetch';

// 获取企业空间列表&&查询企业
export async function getEnterpriseListApi(params: any): Promise<any> {
  return request(`/account/v1/boss/enterprise/list`, {
    tokenFree: false,
    method: 'GET',
    params: params,
  });
}

// 创建企业空间
export async function createEnterpriseApi(params: any): Promise<any> {
  return request(`/account/v1/boss/enterprise/create`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 转移企业空间
export async function transmitEnterpriseApi(params: any): Promise<any> {
  return request(`/account/v1/boss/enterprise/transmit`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 编辑企业空间
export async function updateEnterpriseApi(params: any): Promise<any> {
  return request(`/account/v1/boss/enterprise/update`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 查询所有公司
export async function getCompanyList(): Promise<any> {
  return request(`/account/v1/company/all`, {
    tokenFree: false,
    method: 'GET',
  });
}

// 查询公司列表 && 搜索
export async function getCompany(params: any): Promise<any> {
  return request(`/account/v1/company`, {
    tokenFree: false,
    method: 'GET',
    params: params,
  });
}

// 新增公司
export async function addCompany(params: any): Promise<any> {
  return request(`/account/v1/company`, {
    tokenFree: false,
    method: 'POST',
    data: params, // name
  });
}

// 修改公司
export async function updateCompany(params: any): Promise<any> {
  return request(`/account/v1/company`, {
    tokenFree: false,
    method: 'PUT',
    data: params, // id && name
  });
}

// 获取权限列表
export async function getPermissionsList(type: any): Promise<any> {
  return request(`/account/v1/permissions/list?type=${type}`, {
    tokenFree: false,
    method: 'GET',
  });
}

// 创建授权码
export async function createAuthorizationCode(params: any): Promise<any> {
  return request(`/account/v1/authorization/code`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 更改授权码 -停用
export async function updateAuthorizationCode(params: any): Promise<any> {
  return request(`/account/v1/authorization/code`, {
    tokenFree: false,
    method: 'PATCH',
    data: params,
  });
}

// 更改授权码
export async function AuthorizationCode(params: any): Promise<any> {
  return request(`/account/v1/authorization/code`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 更改授权码状态
export async function updateAuthorizationStatus(params: any): Promise<any> {
  return request(`/account/v1/authorization/code/status`, {
    tokenFree: false,
    method: 'PATCH',
    data: params,
  });
}

// 获取授权码列表
export async function getAuthorizationStatus(params: any): Promise<any> {
  return request(`/account/v1/authorization/code/page`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 获取授权码权限列表
export async function getByProductCode(): Promise<any> {
  return request(`/account/v1/modules/getByProductCode`, {
    tokenFree: false,
    method: 'GET',
    params: { productCode: 'boss' },
  });
}

// 获取授权码创建上限
export async function getCodeCount(): Promise<any> {
  return request(`/account/v1/authorization/code/count`, {
    tokenFree: false,
    method: 'GET',
  });
}

// 用于在boss平台配置默认入口的信息
// 获取入口权限列表
export async function getProjectPermissionList(type?: any): Promise<any> {
  return request(`/account/v1/menu/list`, {
    tokenFree: false,
    method: 'GET',
    params: {
      type: type,
    },
  });
}
// 新增入口权限列表
export async function addProjectPermissionList(params: any): Promise<any> {
  return request(`/account/v1/menu/add`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}
// 修改入口权限列表
export async function updateProjectPermissionList(params: any): Promise<any> {
  return request(`/account/v1/menu/update`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}
// 删除入口权限列表
export async function deleteProjectPermissionList(id: any): Promise<any> {
  return request(`/account/v1/menu/${id}`, {
    tokenFree: false,
    method: 'DELETE',
  });
}

// 获取不同应用的权限列表
export async function getActionsCodeList(name?: any): Promise<any> {
  return request(`/account/v1/actions/list`, {
    tokenFree: false,
    method: 'GET',
    params: {
      name: name,
    },
  });
}

// 获取授权码时间单位
export async function getTimeUnite(): Promise<any> {
  return request(`/account/v1/authorization/code/timeUnite`, {
    tokenFree: false,
    method: 'GET',
  });
}
